import { DEFAULT_THEME_CONFIG } from '@zhenguo/vue-jssdk/business/VerifyEduForm/utils'
import installPageConfig from '@zhenguo/jssdk/page-config'
import { getSource } from '@/utils'

const THEME_NATIVE = {
  ...DEFAULT_THEME_CONFIG,
  key: 'native',
  bgColor: '#f7f8fA',
  mpShareImage: 'https://img.meituan.net/scarlett/841752e4fce82c5f3d1083ccf1dd14d265764.jpg',
  shareImage: 'https://img.meituan.net/scarlett/5926291f069511d9122b43403e763ca159955.jpg',
  btnStyle: {},
  bottomStyle: {},
  loginFirst: true,
  source: 0,
}

async function themes(themeNative) {
  if (themeNative) {
    return Promise.resolve({
      ...THEME_NATIVE,
      source: getSource(THEME_NATIVE),
    })
  }
  let theme = await installPageConfig(DEFAULT_THEME_CONFIG)
  return {
    ...theme,
    source: getSource(theme),
  }
}

export async function installTheme(themeNative) {
  try {
    const theme = await themes(themeNative)
    return {
      theme,
      themeNative,
    }
  } catch (res) {
    return {
      theme: THEME_NATIVE,
      themeNative: true,
    }
  }
}
